import { createSelector } from 'reselect';
import { State } from 'reducers';

export const getAlarmMap = (state: State) => state.alarm.data;

export const getAlarmIdSequence =
    createSelector(
        getAlarmMap,
        alarmMap => Object.keys(alarmMap).sort((id1, id2) =>
            alarmMap[id1].time - alarmMap[id2].time
        )
    );

export const isLoadingAlarms = (state: State) => state.alarm.loading;

export const getAlarmsError = (state: State) => state.alarm.error;



// WEBPACK FOOTER //
// ./src/selectors/alarmSelectors.ts